export interface TenantContext {
  id: string;
  code: string;
  name: string;
  timezone: string;
  locale: string;
}

export interface TenantBranding {
  tenantId: string;
  displayName: string;
  logoAvailable: boolean;
  logoUrl: string | null;
  faviconAvailable: boolean;
  faviconUrl: string | null;
  version: number;
  updatedAt: string | null;
}

/** 只接受当前可信租户的同源、带内容版本的图标地址。 */
export function resolveTenantFavicon(branding: TenantBranding | undefined, tenantId: string | undefined): string | null {
  if (!tenantId || branding?.tenantId !== tenantId || !branding.faviconAvailable) return null;
  const url = branding.faviconUrl;
  return url && /^\/api\/public\/tenant\/branding\/favicon\?v=[a-f0-9]{64}$/.test(url) ? url : null;
}
